export enum ResourceAvailabilityStatus {
  Unavailable = "Unavailable",
  Available = "Available",
  OnCall = "OnCall",
}
